export const FETCH_MARKETDATA_BEGIN = "FETCH_MARKETDATA_BEGIN";
export const FETCH_MARKETDATA_SUCCESS = "FETCH_MARKETDATA_SUCCESS";
export const FETCH_MARKETDATA_FAILURE = "FETCH_MARKETDATA_FAILURE";


export const FETCH_MARKETDATADETAILS_BEGIN = "FETCH_MARKETDATADETAILS_BEGIN";
export const FETCH_MARKETDATADETAILS_SUCCESS = "FETCH_MARKETDATADETAILS_SUCCESS";
export const FETCH_MARKETDATADETAILS_FAILURE = "FETCH_MARKETDATADETAILS_FAILURE";


